module.exports = __webpack_public_path__ + "static/media/telecommunication.1c592b52.mp3";